<style scoped lang="less">
    .line-container{
        width:100%;
    }
    .echarts-line{
        width:100%;
        height:300px;
    }
</style>

<template>
    <div class="line-container">
        <div class="echarts-line" :id="lineId"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    /** 
     * 消缺 55AAED
     * 发现 #B489DB
     * 遗留 FD9999
    */
    export default {
        props : ['lineId','yUnit','data'],
        data() {
            return {
            }
        },
        methods: {
            init() {
                let stationLine = echarts.init(
                    document.getElementById(this.lineId)
                );
                let option = {
                    legend: {
                        data: ['本期', '上期']
                    },
                    color:['#F6BD16','#FF99C3'],
                    grid: {
                        x: 50,
                        y: 40,
                        x2: 30,
                        y2: 35
                    },
                    xAxis: {
                        type: 'category',
                        data: this.data.xAxis,//['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        name: this.yUnit,
                        type: 'value',
                        axisLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            name: '本期',
                            type: 'line',
                            lineStyle:{
                                color:'#F6BD16'
                            },
                            data: this.data.thisData,//[120, 132, 101, 134, 90, 230, 210]
                        },
                        {
                            name: '上期',
                            type: 'line',
                            lineStyle:{
                                color:'#FF99C3'
                            },
                            data: this.data.lastData,//[220, 182, 191, 234, 290, 330, 310]
                        },
                    ]
                };
                stationLine.setOption(option);
            },
        },
        mounted() {
            this.init();
        }
    }
</script>